export const loadImage = async (src: any, width = undefined, height = undefined): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    let img = new Image(width, height);
    img.onerror = reject;
    img.src = src;
    return (img.onload = (i: Event) => {
      img = i.target as HTMLImageElement;
      return resolve(img);
    });
  });
};
